import { render } from "./AticleDetail.vue?vue&type=template&id=00a619f6&scoped=true"
import script from "./AticleDetail.vue?vue&type=script&lang=js"
export * from "./AticleDetail.vue?vue&type=script&lang=js"

import "./AticleDetail.vue?vue&type=style&index=0&id=00a619f6&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a619f6"]])

export default __exports__